module.exports = __webpack_public_path__ + "static/media/1.d96b02ff.jpg";